export default __webpack_public_path__ + "7fbaf8e9a69d8f2e3422ade2efcd373c.svg";